<div [ngClass]="'m-pill m-pill-' + this.type">
  @if (showIcon) {
    <span class="material-symbols-outlined icon-small">
      {{ iconMap[type] }}
    </span>
  }
  <span class="c2 text-gray-1000">{{ text }}</span>
</div>
